import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { COMMON_FAIL_MESSAGE } from "Constants";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  handleLessonModal,
  courseCurrentChapterOpen,
  updateSortedLessons,
  updateTemporaryLessonRanking,
  fetchAllUnpublishedCourses,
  openChapterModal,
  deleteChapter,
} from "CourseAction";
import CourseChapterLessons from "./course-chapter-lesson-list";
import AddChapter from "./add-chapter";
import LocaleStrings from "Languages";

// userd for sort content list
const DragHandle = sortableHandle(() => (
  <div className="drag_container">
    <img
      src="../../style/images/drag_sign.png"
      className="drag_sign_image mt-20"
    />
  </div>
));
const SortableItem = SortableElement(
  ({ value, sortIndex, chapter, source, finishOperationsCallback }) => (
    <div className="d-flex">
      <DragHandle />
      <CourseChapterLessons
        printItem={value}
        chapter={chapter}
        source={source}
        finishOperationsCallback={finishOperationsCallback}
      />
    </div>
  )
);
const SortableList = SortableContainer(
  ({ items, chapter, source, finishOperationsCallback }) => {
    return (
      <div className="lesson-group-list">
        {items.map((value, index) => {
          return (
            <SortableItem
              key={`lesson_key_${index}`}
              index={index}
              value={value}
              chapter={chapter}
              source={source}
              finishOperationsCallback={finishOperationsCallback}
            />
          );
        })}
      </div>
    );
  }
);

class CourseChapters extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  openModel = (e) => {
    let { printItem } = this.props;
    var key = e.currentTarget.attributes["data-key"].value;

    this.props.handleLessonModal({
      showModal: true,
      lessonType: key,
      chapteData: printItem,
    });
  };

  edit = () => {
    let { printItem } = this.props;

    this.props.openChapterModal({ showModal: true, chapterData: printItem });
  };

  delete = () => {
    let { printItem, session } = this.props;
    let courseid = printItem.courseid;

    confirmAlert({
      title: LocaleStrings.course_chapter_delete_chapter,
      message: LocaleStrings.course_chapter_delete_chapter_confirmation,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.deleteChapter(session, printItem, (response) => {
              if (response.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
              } else {
                this.finishOperationsCallback();
                this.props.fetchAllUnpublishedCourses(
                  session,
                  courseid,
                  (res) => {
                    this.props.showSuccess(
                      LocaleStrings.course_chapter_delete_success
                    );
                  }
                );
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  toggleStep(current) {
    let { currentChapterOpen } = this.props;
    let action =
      currentChapterOpen && currentChapterOpen.currentStep == current
        ? ""
        : current;

    this.props.courseCurrentChapterOpen({ currentStep: action });
  }

  finishOperationsCallback = () => {
    this.props.finishOperationsCallback();
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    let { session, lessons, initialValues } = this.props;
    var courseid = initialValues.courseid;
    lessons = arrayMove(lessons, oldIndex, newIndex);

    var newArrAvailable = [];

    //Just map the array and reset the taborder as now taborder is same as the object position
    lessons.map((value, index) => {
      newArrAvailable.push({ ...value, ranking: index + 1 });
    });

    this.props.updateTemporaryLessonRanking(newArrAvailable);

    this.props.updateSortedLessons(session, newArrAvailable, (response) => {
      this.finishOperationsCallback();
      this.props.fetchAllUnpublishedCourses(session, courseid, (res) => {
        this.props.updateTemporaryLessonRanking({});
      });
    });
  };

  renderLessons = () => {
    var { lessons, printItem, source } = this.props;

    return _.map(lessons, (item, index) => {
      return (
        <CourseChapterLessons
          key={`lesson_key_${index}`}
          printItem={item}
          chapter={printItem}
          source={source}
        />
      );
    });
  };

  render() {
    var {
      stepName,
      printItem,
      lessons,
      step,
      displayChild,
      source,
      tempLessonRanking,
      chapterModal,
    } = this.props;

    // this temporary lesson ranking is used for quick display sorted lessons in UI and later it comes from db and again keep the tempLessonRanking as ''.
    if (tempLessonRanking && tempLessonRanking.length > 0) {
      lessons = tempLessonRanking;
    }

    return (
      <div className="w-100">
        <div className="course-lessons-chapter-main-div">
          <div className="chapter-details" data-data_id={stepName}>
            <div className="row">
              <div className="col-md-6 chapter-name">
                {printItem.chaptername}
                &nbsp;
                {source == "main-page" ? (
                  <i
                    onClick={this.edit}
                    className="fa fa-pencil"
                    aria-hidden="false"
                  ></i>
                ) : (
                  ""
                )}
              </div>

              <div className="col-md-6 chapter-actions">
                {source == "main-page" ? (
                  <span className="chapter-action chapter-action-icon">
                    <i
                      onClick={this.delete}
                      className="fa fa-trash"
                      aria-hidden="true"
                    ></i>
                  </span>
                ) : (
                  ""
                )}
                <span
                  className="chapter-action chapter-action-text"
                  onClick={() => this.toggleStep(stepName)}
                >
                  {step}
                </span>
              </div>
            </div>
          </div>
        </div>

        {displayChild ? (
          <div className="course-lessons-details-main-div">
            {source == "main-page" ? (
              <SortableList
                useDragHandle
                onSortEnd={this.onSortEnd}
                items={lessons}
                chapter={printItem}
                source={source}
                finishOperationsCallback={this.finishOperationsCallback}
                //pressDelay={200}
                lockAxis="y"
              />
            ) : (
              this.renderLessons()
            )}

            {source == "main-page" ? (
              <div className="lessons-new-button-section">
                <Button
                  className="btn-custom-white"
                  data-key="old-chapter"
                  onClick={this.openModel}
                >
                  {LocaleStrings.button_add_new_lesson}
                </Button>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        {chapterModal && chapterModal.showModal ? (
          <AddChapter
            finishOperationsCallback={this.finishOperationsCallback}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var toEdit = false;
  var initVals = {};

  if (
    state.allUnpublishedCourseList &&
    state.allUnpublishedCourseList.count > 0
  ) {
    initVals = state.allUnpublishedCourseList.resource[0];
  }

  return {
    session: state.session,
    editMode: toEdit,
    initialValues: initVals,
    currentChapterOpen: state.currentChapterOpen,
    tempLessonRanking: state.tempLessonRanking,
    chapterModal: state.chapterModal,
  };
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  handleLessonModal,
  courseCurrentChapterOpen,
  updateTemporaryLessonRanking,
  updateSortedLessons,
  fetchAllUnpublishedCourses,
  openChapterModal,
  deleteChapter,
})(CourseChapters);
